import React from 'react';
import styles from './seperator.module.scss';
export const Seperator = () => React.createElement("div", { className: styles.seperator });
//# sourceMappingURL=seperator.js.map